/**
 * THE NATIVE SEAM.
 *
 * One rule, and it is the rule that lets one codebase be an iPhone app and a website:
 * **nothing outside this folder may import a Capacitor plugin.** Features import from
 * here; each module below exports one interface with a native path and a web path, picked
 * once at load.
 *
 * Three things fall out of it. The web build never ships a control that cannot work. The
 * test suite runs with no device and no plugin mocks scattered through features. Adding
 * Android later touches this folder and nothing else.
 *
 * eslint enforces it (see eslint.config.js → no-restricted-imports).
 */
import { Capacitor } from "@capacitor/core";

export const isNative = Capacitor.isNativePlatform();
export const platform = Capacitor.getPlatform() as "ios" | "android" | "web";
export const isIOS = platform === "ios";

export * from "./storage";
export * from "./haptics";
export * from "./status-bar";
export * from "./splash";
export * from "./keyboard";
export * from "./network";
export * from "./push";
export * from "./links";
export * from "./camera";
